/*
 * MISHEL storefront behaviour
 * 1. Gift sync: 3+ jewelry items in the cart -> the care set (glass box + spray) is added as a gift;
 *    the automatic "Buy X get Y" discount makes it free. Removed again when the cart drops below 3.
 * 2. Add-on buttons ([data-m-add]) inside the cart drawer.
 * 3. "Secret gift" sign-up popup.
 * Uses Shopify.actions.updateCart so Horizon refreshes the cart drawer by itself.
 */
(() => {
  const GIFT_VARIANT = '67771867136160';
  const GIFT_PROP = '_mishel_gift';
  const ACCESSORY_TYPE = 'אביזרים';
  const GIFT_AT = 3;
  const LINES_EVENT = 'shopify:cart:lines-update';

  const actions = () => (window.Shopify && window.Shopify.actions) || null;
  const cartUrl = () => ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart') + '.js';

  let busy = false;
  let again = false;

  async function syncGift() {
    const api = actions();
    if (!api) return;
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      const res = await fetch(cartUrl(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      let jewelry = 0;
      let anyGiftLine = null;
      let autoGiftLine = null;
      for (const item of cart.items || []) {
        if (String(item.variant_id) === GIFT_VARIANT) {
          anyGiftLine = anyGiftLine || item;
          if (item.properties && item.properties[GIFT_PROP]) autoGiftLine = item;
          continue;
        }
        if (item.product_type !== ACCESSORY_TYPE) jewelry += item.quantity;
      }

      if (jewelry >= GIFT_AT && !anyGiftLine) {
        await api.updateCart({
          lines: [{ merchandiseId: GIFT_VARIANT, quantity: 1, attributes: [{ key: GIFT_PROP, value: '1' }] }],
        });
      } else if (jewelry < GIFT_AT && autoGiftLine) {
        await api.updateCart({ lines: [{ id: autoGiftLine.key, quantity: 0 }] });
      } else if (autoGiftLine && autoGiftLine.quantity > 1) {
        await api.updateCart({ lines: [{ id: autoGiftLine.key, quantity: 1 }] });
      }
    } catch (error) {
      console.warn('[MISHEL] gift sync failed', error);
    } finally {
      busy = false;
      if (again) {
        again = false;
        setTimeout(syncGift, 120);
      }
    }
  }

  document.addEventListener(
    LINES_EVENT,
    (event) => {
      const done = event && event.promise ? event.promise : Promise.resolve();
      done.then(() => setTimeout(syncGift, 80)).catch(() => {});
    },
    true
  );

  // Add-on buttons in the cart drawer
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-m-add]');
    if (!button) return;
    const api = actions();
    if (!api) return;
    event.preventDefault();
    const label = button.textContent;
    button.disabled = true;
    button.textContent = '…';
    try {
      await api.updateCart({ lines: [{ merchandiseId: button.dataset.mAdd, quantity: 1 }] });
    } catch (error) {
      console.warn('[MISHEL] add-on failed', error);
    } finally {
      button.disabled = false;
      button.textContent = label;
    }
  });

  // "Secret gift" popup
  const KEY = 'mishel_gift_v1';
  const store = {
    get() {
      try {
        return window.localStorage.getItem(KEY);
      } catch (e) {
        return null;
      }
    },
    set(value) {
      try {
        window.localStorage.setItem(KEY, value);
      } catch (e) {
        /* storage blocked */
      }
    },
  };

  function initPopup() {
    const popup = document.getElementById('m-gift');
    if (!popup) return;
    const tab = document.querySelector('[data-m-gift-open]');
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    let lastFocus = null;

    const open = () => {
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('m-gift-open');
      if (tab) tab.hidden = true;
      const field = popup.querySelector('input[type="email"]') || popup.querySelector('.m-gift__card a, .m-gift__card button');
      if (field) setTimeout(() => field.focus(), 60);
    };
    const close = () => {
      popup.hidden = true;
      document.documentElement.classList.remove('m-gift-open');
      if (store.get() !== 'done') {
        store.set('closed');
        if (tab) tab.hidden = false;
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    popup.addEventListener('click', (event) => {
      if (event.target.closest('[data-m-gift-close]')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) close();
    });
    if (tab) tab.addEventListener('click', open);

    const state = popup.dataset.state;
    if (state === 'success') {
      store.set('done');
      open();
      return;
    }
    if (state === 'error') {
      open();
      return;
    }
    const saved = store.get();
    if (saved === 'done') return;
    if (saved === 'closed') {
      if (tab) tab.hidden = false;
      return;
    }
    if (tab) tab.hidden = false;
    if (designMode || /^\/(cart|checkouts?)/.test(window.location.pathname)) return;
    setTimeout(() => {
      if (store.get() === null && popup.hidden) open();
    }, 7000);
  }

  function boot() {
    initPopup();
    setTimeout(syncGift, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();